import React, { useEffect, useState } from 'react';
import { CTAButton, CHECKOUT_URL } from './ui/CTAButton';
export function HeroSection() {
  const [timeLeft, setTimeLeft] = useState(13 * 60 + 11); // 13:11 in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeString = timeLeft > 0 ? `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}` : '00:00';
  return <section className="relative w-full bg-white pb-12" data-id="element-173">
      {/* Sticky Timer Bar */}
      <div className="sticky top-0 z-50 w-full bg-red-600 text-white text-center py-3 font-bold text-lg md:text-xl shadow-md" data-id="element-174">
        {timeLeft > 0 ? `⏳ OFERTA EXPIRA EN: ${timeString} | 🔥` : '⏳ OFERTA EXPIRADA | 🔥'}
      </div>

      <div className="max-w-3xl mx-auto px-4 pt-8 text-center" data-id="element-175">
        <p className="text-sm md:text-base font-semibold text-gray-600 mb-4 uppercase tracking-wider" data-id="element-176">
          👨‍👩‍👧 Para padres que quieren estimular el aprendizaje de sus hijos sin
          depender de pantallas
        </p>

        <h1 className="text-4xl md:text-6xl font-black text-gray-900 leading-tight mb-6" data-id="element-177">
          🎨 Mega Pack Actividades para Niños
        </h1>

        <a href={CHECKOUT_URL} className="block mb-8 transform transition hover:scale-[1.02]" data-id="element-178">
          <img src="https://cdn.magicpatterns.com/uploads/ckgkavBjXxDS56EhcD7ajp/landing_-_Editada.png" alt="Mega Pack Actividades para Niños" className="w-full max-w-2xl mx-auto drop-shadow-2xl rounded-xl" width={665} height={665} style={{
          aspectRatio: '1/1'
        }} fetchPriority="high" decoding="async" data-id="element-179" />
        </a>

        <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6 leading-relaxed" data-id="element-180">
          Todo lo que necesitas para estimular el aprendizaje, la creatividad y
          el desarrollo de tu hijo desde casa y de forma divertida.
        </h2>

        <div className="bg-yellow-50 border-2 border-yellow-200 rounded-xl p-6 mb-8 inline-block text-left" data-id="element-181">
          <ul className="space-y-3 text-lg font-medium text-gray-800" data-id="element-182">
            <li className="flex items-center gap-2" data-id="element-183">
              <span className="text-green-500 text-xl" data-id="element-184">✓</span> Actividades
              educativas listas para usar.
            </li>
            <li className="flex items-center gap-2" data-id="element-185">
              <span className="text-green-500 text-xl" data-id="element-186">✓</span> Sin
              complicaciones. Sin preparación previa.
            </li>
          </ul>
        </div>

        <CTAButton data-id="element-187" />

        <p className="mt-4 text-gray-600 font-medium flex items-center justify-center gap-2" data-id="element-188">
          <span className="text-green-500" data-id="element-189">✅</span> Garantía de satisfacción de
          7 días
        </p>
      </div>
    </section>;
}